module.exports = __webpack_public_path__ + "img/doctor.83ddeeca.jpg";